var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.474.025C7.84.025 0 7.865 0 17.5c0 9.634 7.84 17.474 17.474 17.474C27.16 35.025 35 27.185 35 17.5S27.16.025 17.474.025zm0 30.388c-7.071 0-12.862-5.79-12.862-12.913 0-7.072 5.79-12.863 12.862-12.863 7.123 0 12.914 5.791 12.914 12.863 0 7.123-5.79 12.913-12.914 12.913z",
    fill: "#E31E26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.83 16.782a3.638 3.638 0 100-7.276 3.638 3.638 0 000 7.276zM21.83 25.494a3.638 3.638 0 100-7.277 3.638 3.638 0 000 7.277zM13.119 25.494a3.638 3.638 0 100-7.277 3.638 3.638 0 000 7.277zM13.119 16.782a3.638 3.638 0 100-7.276 3.638 3.638 0 000 7.276z",
    fill: "#E31E26"
  })));
}

export default SvgIcon;